import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MsxIcons from "../../features/msx-icons";

const DefaultIconWrapper = styled.div`
  display: block;
`;

const HoverIconWrapper = styled.div`
  display: none;
`;

const IconWrapper = styled.div`
  :hover {
    ${DefaultIconWrapper} {
      display: none;
    }

    ${HoverIconWrapper} {
      display: block;
    }
  }
`;

class InformationIcon extends React.PureComponent {

  static propTypes = {
    size: PropTypes.string,  // Schneider Electric sizes allowed (nano, small, medium, large, xlarge)
  }

  render() {
    const size =this.props.size || 'small';
    return (
      <IconWrapper>
        <DefaultIconWrapper>
          <MsxIcons name="info" size={size}></MsxIcons>
        </DefaultIconWrapper>
        <HoverIconWrapper>
          <MsxIcons name="info_hover" size={size}></MsxIcons>
        </HoverIconWrapper>
      </IconWrapper>
    );
  }
}

export default InformationIcon;
